// NOTE: This file should be exported to seek-jobs-seo
import {
  qualifyUrl,
  isQualifiedUrlNofollow,
  isLocalHoustonLocation as shouldQualifyLocation
} from '@seek/seek-jobs-seo';

function toSeoLocation(location) {
  return {
    path: location.pathname,
    query: location.query
  };
}

function fromSeoLocation({ path, query }) {
  return {
    pathname: path,
    query
  };
}

export function qualifyLocation(locale, location, currentLocation) {
  const { path, query } = toSeoLocation(location);
  return shouldQualifyLocation(location, currentLocation)
    ? {
        ...location,
        ...fromSeoLocation(qualifyUrl(locale, path, query))
      }
    : location;
}

export function isQualifiedLocationNoFollow(location, currentLocation) {
  return (
    shouldQualifyLocation(location, currentLocation) &&
    isQualifiedUrlNofollow(toSeoLocation(location))
  );
}
